import { render, staticRenderFns } from "./AddClientButton.vue?vue&type=template&id=a7d3471c&scoped=true"
import script from "./AddClientButton.vue?vue&type=script&lang=js"
export * from "./AddClientButton.vue?vue&type=script&lang=js"
import style0 from "./AddClientButton.vue?vue&type=style&index=0&id=a7d3471c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d3471c",
  null
  
)

export default component.exports